import http from '@/utils/http'
import _ from 'lodash'
import { INTERFACE } from '@/utils/INTERFACE'
import {SplitQueue} from '@/utils/queue'
export async function getPresale(skus) {
    skus=_.uniq(skus).filter(id=>!!id)
    var queue=new SplitQueue(async ids=>{ 
        let res = await http.jsonp.get(INTERFACE().presale, {
            skus:ids.join(",")
        },true)
        return res
    },20) 
    let data=await queue.fetch(skus) 
    if(data.error){
        throw new Error(data.error)
    }
    return data
}